<template>
  <div
    class="bg-white shadow overflow-hidden max-w-3xl mx-auto my-12  sm:rounded-lg"
  >
    <div v-if="!isLoading && checkout">
      <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
        <h3
          class="text-lg leading-6 font-medium text-gray-900 flex justify-between"
        >
          Order details
          <SendMessageDropdown :checkout="checkout" />
        </h3>
      </div>
      <div class="px-4 py-5 sm:p-0">
        <dl>
          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Customer
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              {{ checkout.customer.firstName }} {{ checkout.customer.lastName }}
            </dd>
          </div>
          <div
            class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Date
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              {{ checkout.createdAt | dateFilter }}
            </dd>
          </div>
          <div
            class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Recovery status
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              <span
                class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full "
                :class="{
                  'bg-red-100 text-red-800': !checkout.isRecovered,
                  'bg-green-100 text-green-800': checkout.isRecovered
                }"
              >
                {{ checkout.isRecovered ? "recovered" : "Not recovered" }}
              </span>
            </dd>
          </div>
          <div
            class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Message status
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              <span
                class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full "
                :class="{
                  'bg-red-100 text-red-800': !checkout.isMessageSent,
                  'bg-green-100 text-green-800': checkout.isMessageSent
                }"
              >
                {{ checkout.isMessageSent ? "Sent" : "Not sent" }}
              </span>
            </dd>
          </div>
          <div
            class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Checkout id
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              {{ checkout.checkoutId }}
            </dd>
          </div>
          <div
            class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Total amount
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              {{ checkout.currency }} {{ checkout.totalPrice }}
            </dd>
          </div>
        </dl>
      </div>
    </div>
    <div class="text-center" v-else>Loading...</div>
  </div>
</template>

<script>
import SendMessageDropdown from "../components/Common/SendMessageDropdown";
import { format } from "date-fns";

export default {
  name: "Checkout",
  components: {
    SendMessageDropdown
  },
  data() {
    return {
      checkout: { customer: {}, createdAt: Date.now() },
      isLoading: false
    };
  },
  filters: {
    dateFilter(value) {
      return format(new Date(value * 1000), "h:mm a, MMM dd");
    }
  },
  async created() {
    this.isLoading = true;
    const checkoutId = this.$route.params.checkoutId;
    await this.loadTemplates();
    const response = await this.$store.dispatch("getCheckout", { checkoutId });

    this.checkout = response.checkout;
    this.isLoading = false;
  },
  methods: {
    loadTemplates() {
      return this.$store.dispatch("getTemplates");
    },
    sendMessage(template) {
      const phoneNumber = this.checkout.customer.phoneNumber.replace(
        /[^a-zA-Z0-9]/g,
        ""
      );
      let body = template.body.replace(
        "{firstName}",
        this.checkout.customer.firstName
      );

      body = body.replace("{lastName}", this.checkout.customer.lastName);
      body = body.replace("{shopUrl}", this.checkout.referringSite);
      body = body.replace("{checkoutUrl}", this.checkout.checkoutUrl);
      body = body.replace(
        "{totalAmount}",
        `${this.checkout.currency} ${this.checkout.totalPrice}`
      );

      const message = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${body}&source&data&app_absent`;

      window.open(message, "_new");
      this.$store.dispatch("updateCheckout", {
        requestParams: { isMessageSent: true },
        checkoutId: this.checkout.id
      });
      this.checkout.isMessageSent = true;
    }
  }
};
</script>

<style lang="scss" scoped></style>
